import { render, staticRenderFns } from "./ViewCustomerTickets.vue?vue&type=template&id=1f87bcdc&scoped=true&lang=pug&"
import script from "./ViewCustomerTickets.vue?vue&type=script&lang=js&"
export * from "./ViewCustomerTickets.vue?vue&type=script&lang=js&"
import style0 from "./ViewCustomerTickets.vue?vue&type=style&index=0&id=1f87bcdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f87bcdc",
  null
  
)

export default component.exports